export const getMenuData = [
  {
    title: 'Cancer Category',
    key: '__cancer_category',
    url: '/cancer-category',
    icon: 'fe fe-activity',
    children: [
      {
        title: 'Breast Cancer',
        key: '__cancer_breast',
        url: '/cancer/breast',
      },
      {
        title: 'Tyroid Cancer',
        key: '__cancer_tyroid',
        url: '/cancer/tyroid',
      },
      {
        title: 'Lymphoma Cancer',
        key: '__cancer_lymphoma',
        url: '/cancer/lymphoma',
      },
      {
        title: 'Head & Neck Cancer',
        key: '__cancer_head_and_neck',
        url: '/cancer/head-and-neck',
      },
      {
        title: 'Skin Cancer',
        key: '__cancer_skin',
        url: '/cancer/skin',
      },
      {
        title: 'Sarcoma Cancer',
        key: '__cancer_sarcoma',
        url: '/cancer/sarcoma',
      },
      {
        title: 'Salivary Gland Cancer',
        key: '__cancer_salivary_gland',
        url: '/cancer/salivary-gland',
      },
      {
        title: 'Miscellaneous Cancer',
        key: '__cancer_miscellaneous',
        url: '/cancer/miscellaneous',
      },
    ],
  },
  {
    title: 'Drugs',
    key: '__drugs',
    url: '/drugs',
    icon: 'fe fe-plus-circle',
  },
  {
    title: 'Users Management',
    key: '__users',
    icon: 'fe fe-user',
    children: [
      {
        title: 'Admin',
        key: '__admin',
        url: '/admin',
      },
      {
        title: 'User',
        key: '__user',
        url: '/user',
      },
    ],
  },

  {
    category: true,
    title: 'Menu Pendukung',
    key: 'category_support',
  },
  {
    title: 'Profil',
    key: '__akun',
    url: '/akun',
    icon: 'fe fe-users',
    // No 'roles' property means it's visible to all logged-in users
  },
]
